export default __webpack_public_path__ + "static/azure-4e7fa0727a7322993626ebf477db8217.jpg";